import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { ItemIcon } from "@similarweb/ui-components";

const { midnight } = colorsPalettes;

export const StyledItemIcon = styled(ItemIcon)`
    width: 24px;
    height: 24px;
    border-color: ${midnight[50]};
`;

export const CellWithLeftPadding = styled.span`
    display: inline-flex;
    padding-left: 14px;
`;

export const DomainIconContainer = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 8px 0px;
`;
export const ValueCell = styled.a<{ isClickable: boolean }>`
    width: 100%;
    height: 100%;
    display: flex;
    cursor: ${({ isClickable }) => (isClickable ? "pointer" : "default")};
    align-items: center;
    justify-content: center;
    color: inherit;
    text-decoration: none;

    &:hover {
        text-decoration: none;
        color: inherit;
    }
`;
